const OrderTracking = ({ orderData }) => {
  return (
    <>
      <ul className="ms-100 border-s-[3px] border-secondary">
        {orderData &&
          orderData.length > 0 &&
          orderData.map((order, index) => (
            <li
              key={index}
              data-date={order?.dateTime}
              className="relative mb-1 last:mb-0 py-2 px-4 before:content-[attr(data-date)] before:min-w-[100px] before:text-[12px]/[18px] before:text-start before:absolute before:end-[calc(100%+20px)] after:absolute after:w-15 after:h-15 after:bg-card-color after:top-10 after:rounded-full after:end-[calc(100%-6px)] after:border-[3px] after:border-primary"
            >
              <div className="font-bold small flex justify-between items-center">
                {order?.description}
              </div>
            </li>
          ))}
      </ul>
    </>
  );
};
export default OrderTracking;
